import { render, staticRenderFns } from "./combine_card.vue?vue&type=template&id=39b930a7&scoped=true&"
import script from "./combine_card.vue?vue&type=script&lang=js&"
export * from "./combine_card.vue?vue&type=script&lang=js&"
import style0 from "./combine_card.vue?vue&type=style&index=0&id=39b930a7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b930a7",
  null
  
)

export default component.exports